<template>
	<div class="sf-table">
		<table class="qms-table">
			<tbody>
				<tr>
					<th class="col-1">* {{ getMessage_('QWCC001137') }}</th>
					<!--라인-->
					<td class="col-1">
						<sf-select-group
							labelPosition="left"
							:inputValue="selectedRow.powLnCd"
							:options="occuPlCdList"
							:onChange="value => onChange({ key: 'powLnCd', value })"
							:placeholder="getMessage_('QWCC001137')"
							:disabled="isOldRow"
						/>
					</td>
					<th class="col-1">* {{ getMessage_('QWCC001030') }}</th>
					<!--공정-->
					<td class="col-1">
						<sf-select-group
							labelPosition="left"
							:inputValue="selectedRow.powPrvsCd"
							:onChange="value => onChange({ key: 'powPrvsCd', value })"
							:options="isOldRow ? allPowPrvsCdList : powPrvsCdList"
							:placeholder="getMessage_('QWCC001030')"
							:disabled="isOldRow"
						/>
					</td>
					<th class="col-1">* {{ getMessage_('QWCC001213') }}</th>
					<!--방식-->
					<td class="col-1">
						<sf-select-group
							labelPosition="left"
							:onChange="value => onChange({ key: 'insnWayCd', value })"
							:options="insnWayCdList"
							:inputValue="selectedRow.insnWayCd"
							:placeholder="getMessage_('QWCC001213')"
						/>
					</td>
					<th class="col-1">* {{ getMessage_('MWCC000891') }}</th>
					<!--사용여부-->
					<td class="col-1">
						<sf-select-group
							labelPosition="left"
							:onChange="value => onChange({ key: 'useYn', value })"
							:options="useYnCdList"
							:inputValue="selectedRow.useYn"
							:placeholder="getMessage_('MWCC000891')"
						/>
					</td>
				</tr>
				<tr>
					<th class="col-1">* {{ getMessage_('QWCC001216') }}</th>
					<!--주기-->
					<td class="col-1">
						<sf-select-group
							labelPosition="left"
							:onChange="value => onChange({ key: 'insnCyclCd', value })"
							:options="insnCyclCdList"
							:inputValue="selectedRow.insnCyclCd"
							:placeholder="getMessage_('QWCC001216')"
						/>
					</td>
					<th class="col-1">* {{ getMessage_('QWCC000920') }}</th>
					<!--시작일자-->
					<td class="col-1">
						<el-date-picker
							:value="selectedRow.vbgStrtDd?.replaceAll('-', '')"
							format="yyyy-MM-dd"
							value-format="yyyyMMdd"
							@input="value => onChange({ key: 'vbgStrtDd', value })"
						/>
					</td>
					<th class="col-1">* {{ getMessage_('QWCC001215') }}</th>
					<!--항목-->
					<td colspan="3" class="col-1">
						<el-input
							:value="selectedRow.insnPrvsSbc"
							@input="value => onChange({ key: 'insnPrvsSbc', value, maxByte: 180 })"
							maxlength="33"
						/>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import { getLimitedByteText } from '@/qmsUtils';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/ptin/PowTourPrvsMng/store/helpers';
export default {
	props: { scrId: { type: String, default: '' } },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async onChange({ key, value, maxByte }) {
			if (key === 'insnPrvsSbc') {
				maxByte ? this.setSelectedRow_({ key, value: getLimitedByteText(value, maxByte) }) : this.setSelectedRow_({ key, value });
				return;
			}

			this.setSelectedRow_({ key, value });

			if (key === 'powLnCd') {
				this.setSelectedRow_({ key: 'powPrvsCd', value: '' });
				await this.setPowPrvsCdList_(); // 발생공정 공통코드 조회
			}
		}
	}
};
</script>

<style></style>
